module.exports = __webpack_public_path__ + "img/diy1.1ed8463f.gif";